import { useMutation } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	BulkAssignCounterpartiesPreviewRes,
	BulkDownloadFileFilters,
} from '@dealstack/shared/lib/generated';

interface BulkAssignCounterpartiesPreviewBody {
	allDocumentsSelected: boolean;
	selectedDocumentWorkflowInstanceIds?: string[];
	excludedDocumentWorkflowInstanceIds?: string[];
	filters?: BulkDownloadFileFilters;
}

export const useBulkAssignCounterpartiesPreview = ({
	dealId,
	programmeId,
}: {
	dealId: string;
	programmeId: string;
}) => {
	return useMutation({
		mutationFn: async (body: BulkAssignCounterpartiesPreviewBody) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_ASSIGN_COUNTERPARTIES_PREVIEW_POST,
				{ dealId, programmeId }
			);
			const response = await makeRequest<ApiV1.Response<BulkAssignCounterpartiesPreviewRes>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});
			return response;
		},
	});
};
